import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { baseURL, basics } from "../../../basics";
import { Link, useHistory } from "react-router-dom";
import DataCategoresItem from "../ListOfProducts/ByCategory/DataCategoresItem";
import Loading from "../../Ui/Loading";
import { useDispatch, useSelector } from "react-redux";
import { fetchShowAllProductsHandler } from "../../../store/category-actions";
import Category from "../Category/Category";
import { categoryActions } from "../../../store/category-slice";
import { FaLeaf } from "react-icons/fa";

function SampleArrow(props: any) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", background: "red", color: "black" }}
      onClick={onClick}
    />
  );
}

const ListOfTypes = () => {
  // const isMounted = useRef<boolean>();
  // const [dataCategory, setDataCategory] = useState([""]);
  // const [response, setResponse] = useState<any>(false);

  // const settings = {
  //   focusOnSelect: true,
  //   infinite: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  //   speed: 500,
  //   nextArrow: <SampleArrow />,
  //   prevArrow: <SampleArrow />,
  //   // rtl: true,
  // };
  const dispatch = useDispatch();
  const history = useHistory();
  const itemsPerPage = useSelector((state: any) => state.category.itemsPerPage);
  const currentPage = useSelector((state: any) => state.category.page);
  const goToAllProductsHandler = () => {
    dispatch(categoryActions.newCategoryIsSelected());
    dispatch(categoryActions.typeOfProductsCategoriesChanger("allProducts"));
    dispatch(fetchShowAllProductsHandler(currentPage, itemsPerPage));
    history.push("/products");
  };
  // useEffect(() => {
  //   if (isMounted.current) return;
  //   axios({
  //     method: "get",
  //     url: `${baseURL}api/Category/GetCategories`,
  //     responseType: "stream",
  //   })
  //     .then(function (response) {
  //       setDataCategory(response.data);
  //       setResponse(true);

  //       // //console.log("DataCATEGORYYYYYYYYYYY", response.data);
  //     })
  //     .catch(function (error: any) {
  //       //console.log("error", error);
  //     });
  //   isMounted.current = true;
  // }, []);
  // if (!response) {
  //   return (
  //     <div className="my-24 mx-auto">
  //       <Loading />
  //     </div>
  //   );
  // }
  return (
    <div className="py-2">
      <div className="flex justify-between items-center px-3 sm:px-4 py-1">
        <h2 className="flex items-center gap-1.5 text-lg sm:text-xl font-bold text-gray-900">
          <FaLeaf className="text-emerald-500 text-base sm:text-lg" />
          {basics.Categories}
        </h2>
        <button
          onClick={goToAllProductsHandler}
          className="text-sm sm:text-base font-medium text-emerald-600 hover:text-emerald-700 hover:underline transition"
        >
          {basics.seeAllProducts}
        </button>
      </div>
      <Category />
    </div>
  );
};

export default ListOfTypes;
